<template>
    <div class="modal-search-bank-employee" v-if="modal_bank">
        <div class="btn-close" @click="modalEmployeeBank"></div>
        <row-component>
            <row-col-component :class-row-col="'col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12'"
                               :class="{'formError' : errors.name}">
                <label>Pago:</label>
                <Multiselect v-model="formData.paid" @select="titleSuggestion(formData.type)"
                             :options="selectEmployeeBankList" :searchable="true"
                             :noOptionsText="noOptionsText" :noResultsText="noResultsText"/>
            </row-col-component>
        </row-component>
        <button-submit @submit="modalEmployeeBank" :items="{nameButton: 'Confimar'}"/>
    </div>

    <painel-component :itens="itensOne">
        <error-component :errors="errors" v-if="showError"/>
        <div class="clearfix">
            <button-route v-if="buttonAdd" class="float-end" :items="buttonRouteAdd"/>
            <button-submit @click="printPDF" class="float-end me-3 border-1" :items="{icon: 'ti ti-printer'}"/>
        </div>

        <form v-if="showView">
            <row-component>
                <row-col-component
                        :class-row-col="'col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12'">
                    <input @click="changeType" v-model="formData.client_employee_provider_type" type="radio" name="docs"
                           id="cliente" value="1">
                    <label for="cliente">Cliente</label>

                    <input @click="changeType" v-model="formData.client_employee_provider_type" type="radio" name="docs"
                           id="fornecedor" value="3">
                    <label for="fornecedor">Fornecedor</label>

                    <input @click="changeType" v-model="formData.client_employee_provider_type" type="radio" name="docs"
                           id="funcionario" value="2">
                    <label for="funcionario">Funcionário</label>
                </row-col-component>
            </row-component>

            <row-component>
                <row-col-component :class-row-col="'col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12'"
                                   :class="{'formError' : errors.type}">
                    <label>Tipo:</label>
                    <Multiselect v-model="formData.type" @select="titleSuggestion(formData.type)"
                                 :options="selectTypeReceiptList" :searchable="true"
                                 :noOptionsText="noOptionsText" :noResultsText="noResultsText"/>
                </row-col-component>

                <row-col-component v-if="parseInt(formData.client_employee_provider_type) === 2"
                                   :class-row-col="'col-xxl-8 col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12'"
                                   :class="{'formError' : errors.client_employee_provider_id}">
                    <label>Funcionário:</label>
                    <Multiselect label="name" v-model="formData.client_employee_provider_id"
                                 :options="selectEmployeeList" :searchable="true"
                                 :noOptionsText="noOptionsText" :noResultsText="noResultsText"/>
                </row-col-component>

                <row-col-component v-else-if="parseInt(formData.client_employee_provider_type) === 3"
                                   :class-row-col="'col-xxl-8 col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12'"
                                   :class="{'formError' : errors.client_employee_provider_id}">
                    <label>Fornecedor:</label>
                    <Multiselect label="name" v-model="formData.client_employee_provider_id"
                                 :options="selectProviderList" :searchable="true"
                                 :noOptionsText="noOptionsText" :noResultsText="noResultsText"/>
                </row-col-component>

                <row-col-component v-else :class-row-col="'col-xxl-8 col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12'"
                                   :class="{'formError' : errors.client_employee_provider_id}">
                    <label>Cliente:</label>
                    <Multiselect label="name" v-model="formData.client_employee_provider_id" :options="selectClientList"
                                 :searchable="true"
                                 :noOptionsText="noOptionsText" :noResultsText="noResultsText"/>
                </row-col-component>
            </row-component>

            <row-component>
                <row-col-component :class-row-col="'col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12'"
                                   :class="{'formError' : errors.title}">
                    <label>Título:</label>
                    <input-component :type-input="'text'" v-model="formData.title"/>
                </row-col-component>

                <row-col-component :class-row-col="'col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12'"
                                   :class="{'formError' : errors.date}">
                    <label>Data:</label>
                    <input-component v-mask="'##/##/####'" :type-input="'text'" v-model="formData.date"/>
                </row-col-component>

                <row-col-component :class-row-col="'col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12'"
                                   :class="{'formError' : errors.price}">
                    <label>Valor:</label>
                    <input-component v-money="money" :type-input="'text'" v-model="formData.price"/>
                </row-col-component>
            </row-component>

            <row-component v-if="formData.client_employee_provider_type === 2">
                <row-col-component :class-row-col="'col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12'"
                                   :class="{'formError' : errors.paid}">
                    <label>Pago:</label>
                    <div class="input-group">
                        <input v-model="formData.paid" type="text" class="form-control">
                        <span @click="modalEmployeeBank" class="input-group-text">
                            <i class="ti ti-search"></i>
                        </span>
                    </div>
                </row-col-component>
            </row-component>

            <row-component v-else>
                <row-col-component :class-row-col="'col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12'"
                                   :class="{'formError' : errors.paid}">
                    <label>Pago:</label>
                    <input-component :type-input="'text'" v-model="formData.paid"/>
                </row-col-component>
            </row-component>

            <row-component>
                <row-col-component :class-row-col="'col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12'"
                                   :class="{'formError' : errors.referent}">
                    <label>Referente:</label>
                    <input-text-area :rows="3" v-model="formData.referent"/>
                </row-col-component>
            </row-component>

            <row-component>
                <row-col-component :class-row-col="'col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12'">
                    <button-submit :disaabled="sendForm" @submit="submit" :items="buttonSubmit" style="width: 100%;"/>
                </row-col-component>

                <row-col-component :class-row-col="'col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12'">
                    <button-route :items="buttonRoute" style="width: 100%;"/>
                </row-col-component>
            </row-component>
        </form>

    </painel-component>
</template>

<script>
import PainelComponent from '@/components/dashboard/PainelComponent';
import RowComponent from '@/components/row/RowComponent';
import RowColComponent from '@/components/row/RowColComponent';
import InputComponent from '@/components/form/InputComponent';
import Multiselect from '@vueform/multiselect';
import ButtonSubmit from '@/components/buttons/ButtonSubmit';
import ButtonRoute from '@/components/buttons/ButtonRoute';
import InputTextArea from '@/components/form/InputTextArea';
import ErrorComponent from "@/components/alerts/ErrorComponent";
import {useToast} from "vue-toastification";
import {MONEY} from "@/configs/constants";
import {VMoney} from "v-money";
import {mask} from "vue-the-mask";

const toast = useToast()
export default {
    name: 'ReceiptUpdate',

    props: {
        id: {
            required: true
        }
    },

    created() {
        this.$store.dispatch('updateNamePage', 'Recibo')
        this.$store.dispatch('loadClientMultiSelect')
        this.$store.dispatch('loadProviderMultiSelect')
        this.$store.dispatch('loadEmployeeMultiSelect')
        this.checkACL()
        this.loadReceipt()
    },

    components: {
        ErrorComponent,
        PainelComponent,
        RowComponent,
        RowColComponent,
        InputComponent,
        Multiselect,
        ButtonSubmit,
        ButtonRoute,
        InputTextArea
    },

    directives: {
        mask,
        money: VMoney
    },

    data() {
        return {
            itensOne: {
                title: "Editar",
                icon: "ti-edit"
            },

            buttonSubmit: {
                icon: 'ti-device-floppy',
                nameButton: 'Salvar',
                typeButton: 'button'
            },

            buttonRoute: {
                icon: 'ti-arrow-back-up',
                route: '/receipt/search',
                name: 'Voltar'
            },

            buttonRouteAdd: {
                icon: 'ti-plus',
                route: '/receipt/create',
            },

            buttonAdd: false,

            formData: {
                type: '',
                title: '',
                client_employee_provider_type: '',
                client_employee_provider_id: '',
                date: '',
                price: '',
                paid: '',
                referent: '',
                link_receipt_pdf: ''
            },

            money: MONEY,

            modal_bank: false,

            errors: [],
            showView: false,
            sendForm: false,
            showError: false,
        }
    },

    methods: {

        loadReceipt() {
            this.$store.dispatch('loadReceipt', this.id)
                .then((r) => {
                    this.formData = r
                }).catch(() => {
                toast.error('Erro desconhecido', {timeout: 2000})
            })
        },

        submit() {
            if (!this.sendForm) {
                this.sendForm = true;
                this.$store.dispatch('updateReceipt', this.formData)
                    .then(() => {
                        this.showError = false
                        this.sendForm = false
                        this.errors = []
                        toast.success("Cadastro atualizado com sucesso", {timeout: 2000});
                    }).catch((r) => {
                    this.showError = true;
                    this.sendForm = false
                    this.errors = r.response.data.errors;
                    this.scrollToTop()
                    toast.error("Seu formulário contém erros verificar!", {timeout: 2000});
                })
            }
        },

        scrollToTop() {
            window.scrollTo(0, 0);
        },

        async checkACL() {
            this.$store.dispatch('ACLitens', 18)
                .then((r) => {
                    if (r.data.indexOf('receipt-edit') !== -1) {
                        this.showView = true

                        if (r.data.indexOf('receipt-create') !== -1) {
                            this.buttonAdd = true
                        }

                    } else {
                        this.$router.push({name: 'home'})
                    }
                }).catch(() => {
                this.$router.push({name: 'home'})
            })
        },

        loadEmployeeBankMultiSelect(id) {
            this.$store.dispatch('loadEmployeeBankMultiSelect', id)
        },

        modalEmployeeBank() {
            this.modal_bank = !this.modal_bank
        },

        printPDF() {
            window.open(this.formData.link_receipt_pdf, '_blank')
        },

        changeType() {
            this.formData.client_employee_provider_id = ''
            this.formData.paid = ''
        },

        titleSuggestion(type) {
            if (parseInt(type) === 1) {
                this.formData.title = "Recibo de pagamento"
            }
            if (parseInt(type) === 2) {
                this.formData.title = "Recibo de recebimento"
            }
            if (parseInt(type) === 3) {
                this.formData.title = "Recibo de pagametno salarial"
            }
            if (parseInt(type) === 4) {
                this.formData.title = "Recibo adiantamento salarial"
            }
            if (parseInt(type) === 5) {
                this.formData.title = "Recibo de pagametno salarial (Prestador de serviço)"
            }
            if (parseInt(type) === 6) {
                this.formData.title = "Recibo adiantamento salarial (Prestador de serviço)"
            }
        },

    },

    computed: {
        selectActiveInative() {
            return this.$store.state.var.selectActiveInative
        },

        noResultsText() {
            return this.$store.state.var.noResultsText
        },

        noOptionsText() {
            return this.$store.state.var.noOptionsText
        },

        selectTypeReceiptList() {
            return this.$store.state.var.selectTypeReceiptList
        },

        selectClientList() {
            return this.$store.state.var.selectClientList
        },

        selectProviderList() {
            return this.$store.state.var.selectProviderList
        },

        selectEmployeeList() {
            return this.$store.state.var.selectEmployeeList
        },

        selectEmployeeBankList() {
            return this.$store.state.var.selectEmployeeBankList
        }
    }

}
</script>

<style scoped>
.input-group-text {
    background-color: #36c1bd;
    border-color: #36c1bd;
    cursor: pointer;
    color: white;
}

.modal-search-bank-employee .btn-close {
    top: 0;
    right: 0;
    margin: 1%;
    position: absolute;
}

.modal-search-bank-employee {
    top: 50%;
    left: 50%;
    width: 40%;
    z-index: 9999;
    position: fixed;
    min-height: 20%;
    margin-right: -50%;
    padding: 40px 20px;
    overflow-y: auto;
    background: #FFFFFF;
    transform: translate(-50%, -50%);
    box-shadow: 10px 10px 23px 0 rgb(204 204 204);
}

@media (max-width: 991px) {
    .modal-search-bank-employee {
        width: 96%;
    }
}
</style>